import {mainQuery} from '@github-ui/react-core/future/main-query'

import {commitsAppBuilder} from '../config/app-builder'

/** Values the commits and commit routes previously read from the deprecated app payload. */
export interface CommitsLayoutPayload {
  helpUrl: string
  findInDiffWorkerPath: string
}

export const commitsLayoutRoute = commitsAppBuilder.createQueryRouteConfig('commitsLayoutRoute', {
  path: '/:owner/:repo',
  queries: [
    mainQuery<CommitsLayoutPayload>({
      // Shared by the commits list and commit detail routes, so the endpoint hangs off the repo
      // path this route matches rather than the child's full path.
      queryDeps: ({pathname}) => ({pathname: `${pathname}/commits/_layout`}),
      staleTimeForNavigation: 360000,
    }),
  ],
})
